import React, { useEffect } from 'react';
import { Translate } from 'core/translate';
import { template } from 'lodash';
import { withModelInfo } from '../../common/ModelInfoContext';
import {
  CONFIG,
  remove,
} from '../../resources/localStorage/localStorage.service';
import ErrorBoundary from '../../common/ErrorBoundary';

const getContactUsURL = ({ brand }) => {
  switch (brand) {
    case 'gmc':
      return 'http://www.gmc.com/contact-us/chat.html';
    case 'buick':
      return 'https://www.buick.com/help/contact-us/form.html';
    case 'chevrolet':
      return 'http://www.chevrolet.com/contact/call-us.html';
    case 'cadillac':
      return 'https://www.cadillac.com/help/contact-us/form.html';
    default:
      return 'https://www.gmfleet.com/contact.html';
  }
};

const getDealerURL = ({ brand }) => {
  switch (brand) {
    case 'gmc':
      return 'https://www.gmc.com/locate-gmc-dealer';
    case 'buick':
      return 'https://www.buick.com/locate-buick-dealer';
    case 'chevrolet':
      return 'https://www.chevrolet.com/dealer-locator';
    case 'cadillac':
      return 'https://www.cadillac.com/locate-dealer';
    default:
      return 'https://www.gmfleet.com/locate-a-dealer';
  }
};

const ErrorContent = ({ modelInfo, data = {} }) => {
  const contactUsUrl = getContactUsURL({ ...modelInfo });
  const dealerUrl = getDealerURL({ ...modelInfo });
  const { assetsUrlTemplate } = modelInfo;
  const heroImageSrc = template(assetsUrlTemplate)({
    filename: 'error-page-hero.jpg',
  });

  return (
    <div className="error-view error-view--centered">
      <div className="error-view__img-container">
        <img
          src={heroImageSrc}
          className="error-view__img"
          alt="horizon view"
        />
      </div>
      <h3 className="error-view__title">
        <Translate value="error.view.title" />
      </h3>
      <div className="error-view__line">
        <Translate value="error.view.error.message" />
      </div>
      <div>
        <div className="error-view__line">
          <Translate value="please.v3" />{' '}
          <a className="error-view__link stat-text-link" href={contactUsUrl}>
            <Translate value="contact.us.v3" />
          </a>{' '}
          <Translate value="or.your.v3" />{' '}
          <a className="error-view__link stat-text-link" href={dealerUrl}>
            <Translate value="local.dealer.v3" />
          </a>{' '}
          <Translate value="questions.for.vehicle.v3" />
        </div>
      </div>
      <ErrorBoundary>
        <div className="error-view__contents">
          -- SESSION: --
          {data.selection}
          -- HEADER: --
          {data.header}
          -- DETAIL: --
          {JSON.stringify(data.detail)}
        </div>
      </ErrorBoundary>
    </div>
  );
};

const Error = (props) => {
  const modelInfo = props.modelInfo;
  const error = props.error || {};
  const data = {
    errorData: error,
    header: error.message,
    detail: error.stack,
    lang: modelInfo.language,
    country: modelInfo.country,
    brand: modelInfo.brand,
    carline: modelInfo.carline,
    modelyear: modelInfo.year,
    bodystyle: modelInfo.bodyStyle,
  };

  useEffect(() => {
    const { modelInfo } = props;

    // clear localStorage config for current vehicle
    remove(modelInfo, CONFIG);
  });

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  return (
    <>
      <ErrorContent modelInfo={modelInfo} data={data} />
    </>
  );
};

export default withModelInfo(Error);
